module.exports = __webpack_public_path__ + "images/navigation/calculator@3x-b7510df1.jpg";